import { FC, PropsWithChildren, SyntheticEvent } from "react";
import { Button, ButtonProps as MantineButtonProps } from "@mantine/core";
import Text, { TextSize } from "../Text";
import styles from "./styles.module.css";

export type CTAIntent = "primary" | "secondary" | "tertiary" | "affirm" | "negate" | "text" | "secondaryGrey";

export interface CTAProps extends MantineButtonProps {
  id?: string;
  intent?: CTAIntent;
  size?: "xs" | "sm" | "md" | "lg";
  onClick?: (event: SyntheticEvent) => void;
  onMouseEnter?: (event: SyntheticEvent) => void;
  onMouseDown?: (event: SyntheticEvent) => void;
  fullWidth?: boolean;
  form?: string;
  type?: "button" | "submit" | "reset";
}

const CTA: FC<PropsWithChildren<CTAProps>> = ({ size = "sm", intent = "primary", fullWidth, ...props }) => {
  return (
    <Button
      form={props.form}
      unstyled={intent === "text"}
      vars={() => ({
        root: {
          "--button-height": `var(--button-${size}-height)`,
          "--button-padding-x": `var(--button-${size}-padding-x)`,
        },
      })}
      classNames={{
        root: `${styles.ctaRoot} ${fullWidth ? styles.ctaRootFullWidth : ""} ${styles[intent]}`,
        inner: styles.inner,
      }}
      tt={intent !== "text" ? "uppercase" : ""}
      {...props}
    >
      <Text
        span={true}
        className={styles.ctaLabel}
        size={size as TextSize}
        display={intent !== "text" ? "technical" : "body"}
      >
        {props.children}
      </Text>
    </Button>
  );
};

export default CTA;
